export const environment = {
  production: false,
  apiUrl: 'https://ec2.backend.rule10b51.staging.eu-central-1.master.2iq.cloud',
  form144ApiUrl: 'https://ec2.form144-backend.x2iq.com',
  oauthProviderUrl: 'https://2iq-staging.auth.eu-central-1.amazoncognito.com/oauth2/authorize',
  clientId: '1tiqd3srsam5stg438l75fn7g4',
  userInfo: 'https://2iq-staging.auth.eu-central-1.amazoncognito.com/oauth2/userInfo'
};
